var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{key:'supportModalChat',ref:"chatDialog",staticClass:"modal--support-chat",attrs:{"title":_vm.$t('support_chat'),"chatMode":true},on:{"close":function($event){return _vm.$emit('close')}}},[_c('support-chat',{on:{"close-chat":function($event){return _vm.$emit('close')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }